import { navLinks } from '@/mocks/home';

const footerGroups = [
  {
    id: 'nav',
    title: '入口导航',
    links: navLinks,
  },
  {
    id: 'quick',
    title: '快速前往',
    links: [
      { id: 'official', label: '官网直达入口', href: '#entrance' },
      { id: 'app', label: 'APP 下载中心', href: '#download' },
      { id: 'backup', label: '备用线路索引', href: '#entrance' },
      { id: 'tags', label: '话题标签墙', href: '#tags' },
    ],
  },
  {
    id: 'help',
    title: '使用帮助',
    links: [
      { id: 'steps', label: '三步使用流程', href: '#top' },
      { id: 'faq', label: '常见问题解答', href: '#faq' },
      { id: 'status', label: '地址状态说明', href: '#address' },
      { id: 'bookmark', label: '收藏本页指引', href: '#top' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-primary-900 text-primary-50">
      <div className="w-full px-4 md:px-10 pt-14 md:pt-16 pb-8">
        <div className="rounded-lg bg-primary-800 px-6 md:px-8 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-12">
          <div>
            <h2 className="font-heading font-bold text-lg md:text-xl text-background-50">
              入口会变，收藏不变
            </h2>
            <p className="mt-1 text-sm text-primary-100/80">
              把青苹果影院官网入口与最新地址放进书签，下次一键直达。
            </p>
          </div>
          <a
            href="#address"
            className="inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-accent-950 font-label text-sm font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap shrink-0"
          >
            <i className="ri-link-m" aria-hidden="true"></i>
            获取最新入口
          </a>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr_1fr] gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-500 text-primary-950 flex items-center justify-center text-2xl">
                <i className="ri-apple-fill" aria-hidden="true"></i>
              </span>
              <span className="font-heading font-black text-xl text-background-50">
                青苹果影院
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-primary-100/80 max-w-xs">
              一个专注于入口与地址整理的中转页，帮你解决找不到网站、地址失效的问题，快速获取有效入口。
            </p>
          </div>

          {footerGroups.map((group) => (
            <div key={group.id}>
              <h3 className="font-heading font-bold text-sm text-background-50 mb-4">
                {group.title}
              </h3>
              <ul className="space-y-2.5">
                {group.links.map((link) => (
                  <li key={link.id}>
                    <a
                      href={link.href}
                      className="font-label text-sm text-primary-100/80 hover:text-accent-300 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-primary-800 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <p className="font-label text-xs text-primary-100/70">
            © 2026 青苹果影院 · 本页仅为入口与地址整理，非官方内容平台
          </p>
          <p className="font-label text-xs text-primary-100/60">
            官网入口 · 最新地址 · APP 下载 · 网址收录
          </p>
        </div>
      </div>
    </footer>
  );
}